import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { CoralogixRum } from '@coralogix/browser'
import { createGtm } from '@gtm-support/vue-gtm'
import * as Sentry from '@sentry/vue'
import { plugin as unleashPlugin } from '@unleash/proxy-client-vue'

CoralogixRum.init({
  public_key: process.env.VUE_APP_CORALOGIX_KEY || 'cxtp_uMAwxJTFkiUDCyJ4uY6jz6TbbAMlvl',
  application: 'storefront',
  version: '2.1',
  coralogixDomain: process.env.VUE_APP_CORALOGIX_DOMAIN || 'US2',
  sessionRecordingConfig: {
    enable: true,
    autoStartSessionRecording: true,
    recordConsoleEvents: true,
    sessionRecordingSampleRate: 100,
    blockClass: 'rr-block',
    ignoreClass: 'rr-ignore',
    maskTextClass: 'rr-mask',
    maskAllInputs: false,
    maskInputOptions: {
      password: true,
      creditCard: true
    },
    maxMutations: 5000,
    recordCanvas: false,
    inlineImages: false,
    collectFonts: false,
    sampling: {
      mousemove: true,
      mouseInteraction: {
        MouseUp: true,
        MouseDown: true,
        Click: true,
        ContextMenu: true,
        DblClick: true,
        Focus: true,
        Blur: true,
        TouchStart: true,
        TouchEnd: true,
      },
      scroll: 150,
      media: 800,
      input: 'last',
    },
  },
})

const app = createApp(App).use(store).use(router)

// Unleash feature flags
app.use(unleashPlugin, {
  config: {
    url: process.env.VUE_APP_UNLEASH_URL || 'https://features.lunchbox.io/api/frontend',
    clientKey: process.env.VUE_APP_UNLEASH_CLIENT_KEY || 'default:production.82d8d38f7ac4258558bc331f7866df8b6444855d977f746282e799e0',
    refreshInterval: 15,
    appName: process.env.VUE_APP_UNLEASH_APP_NAME || 'default'
  }
})

Sentry.init({
  app,
  dsn: 'https://9e74111a15a1a1c35ec017d52086f4cf@o360216.ingest.sentry.io/4505833645146112',
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

// google tag manager
if (process.env.VUE_APP_GTM_ID) {
  try {
    let gtm = createGtm({
      id: process.env.VUE_APP_GTM_ID,
      enabled: true,
      debug: false,
      vueRouter: router,
    })
    if (gtm) {
      app.use(gtm);
    }
  }
  catch (error) {
    console.log(error)
  }
}

// google analytics
const gaId = process.env.VUE_APP_GA4_ID
if (gaId) {
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`
  document.head.appendChild(script)

  const configScript = document.createElement('script')
  configScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${gaId}');
  `
  document.head.appendChild(configScript)
}


app.mount('#app')
